import type { Meta } from "../types";

/**
 * The lookup tables from inc/global_arrays.php, fetched once at start-up.
 *
 * The converted document templates read these synchronously while rendering
 * (the PHP originals had the arrays `require`d into scope), so this is a module
 * singleton filled in before the first form can be opened rather than a hook.
 */
export const META: Meta & { monthsEn: Record<string, string> } = {
  site: { name: "", patsPerPage: 30, waTemplate: "" },
  months: {},
  monthsMood: {},
  monthsEn: {
    "1": "January", "2": "February", "3": "March", "4": "April",
    "5": "May", "6": "June", "7": "July", "8": "August",
    "9": "September", "10": "October", "11": "November", "12": "December",
  },
  sex: {},
  eyes: {},
  docTypes: {},
  sources: {},
  printForms: {},
  protocols: { a: {}, s: {} },
  years: [],
};

export function setMeta(next: Meta) {
  Object.assign(META, next);
}
